<template>
  <div>
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control" @keypress.enter="find()" v-model="query.generic"
          placeholder="Pesquisar por nome, CPF ou telefone">
        <search-icon @click="find()" class="icon icon-within" />
      </div>

      <button class="col-md-1 ml-2 btn-sm btn-outline nowrap" :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{ 'rotate-90': showFilter }" />
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query" @clearBadge="find()" @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges" :filters="badgesFilters" />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="driver-account">Conta</label>
          <Select2 :options="filterAccount" v-model="query.accountId" id="driver-account"
            title-load="Carregando contas..." />
        </div>

        <div class="col-md-4">
          <label for="driver-created-by">Criado por</label>
          <Select2 :options="filterCreatedBy" v-model="query.createdBy" id="driver-created-by"
            title-load="Carregando emails..." />
        </div>

        <div class="col-md-4">
          <label for="driver-updated-by">Atualizado por</label>
          <Select2 :options="filterUpdatedBy" v-model="query.updatedBy" id="driver-updated-by"
            title-load="Carregando emails..." />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4">
          <label for="driver-category">Categoria</label>
          <Select2 :options="filterCategory" v-model="query.category" id="driver-category" />
        </div>

        <div class="col-md-4">
          <label for="driver-cnh-status">Status da CNH</label>
          <Select2 :options="filterCnhStatus" v-model="query.cnhStatus" id="driver-cnh-status" />
        </div>

        <div class="col-md-4">
          <label for="driver-responsibility-term-status">Status do Termo</label>
          <Select2 :options="filterResponsibilityTermStatus" v-model="query.responsibilityTermStatus"
            id="driver-responsibility-term-status" />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4">
          <label for="type-period">Tipo do periodo</label>
          <select v-model="query.periodType" id="type-period" class="form-control">
            <option value="created_at">Data de criacao</option>
            <option value="">Data de atualizacao</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <strong class="mr-3">
          {{ infoTotalModels }}
        </strong>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="orderBy" class="browser-default custom-select">
            <option value="updated_at">Data de atualizacao</option>
            <option value="created_at">Data de criacao</option>
            <option value="name">Nome</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-sm-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nome</th>
              <th>CPF</th>
              <th>Telefone</th>
              <th>Categoria</th>
              <th>Status da CNH</th>
              <th>Status do Termo</th>
              <th>Conta</th>
              <th>Criado por</th>
              <th>Atualizado por</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="driver in drivers" :key="driver.id">
              <td>{{ driver.id }}</td>
              <td>{{ driver.name || '-' }}</td>
              <td>{{ formatCpf(driver.cpf) }}</td>
              <td>{{ formatPhone(driver.phone) }}</td>
              <td>{{ driver.category || '-' }}</td>
              <td>{{ translateStatus(driver.cnhStatus) }}</td>
              <td>{{ translateStatus(driver.responsibilityTermStatus) }}</td>
              <td>{{ getAccountName(driver) }}</td>
              <td>{{ driver.createdBy || '-' }}</td>
              <td>{{ driver.updatedBy || '-' }}</td>
              <td>{{ driver.createdAt | datetime }}</td>
              <td>{{ driver.updatedAt | datetime }}</td>
              <td>
                <button @click="showDriver(driver)" class="btn btn-outline">Detalhes</button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination v-model="meta.currentPage" :total-count="meta.totalCount" :total-pages="meta.totalPages"
              @pagination="pagination" />
          </div>
        </div>
      </div>

      <ShowDataModal v-if="currentDriver" v-model="showModal" :header="currentDriver.name" :data="currentDriver"
        :deep="3" />
    </div>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import GlobalLoading from '@/mixins/GlobalLoading'
import ModelMapper from '@/mixins/ModelMapper'
import Pagination from '@/components/shares/specialTag/Pagination'
import Select2 from '@/components/shares/Select2'
import ShowDataModal from '@/components/admin/ShowDataModal'
import handleSearchable from '@/models/handleSearchable'
import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
import { Filter } from '@/models/filter'

export default {
  components: { BadgeFilters, ChevronDownIcon, Pagination, SearchIcon, Select2, ShowDataModal },
  computed: {
    badgesFilters() {
      return [
        this.filterAccount,
        this.filterCreatedBy,
        this.filterUpdatedBy,
        this.filterCategory,
        this.filterCnhStatus,
        this.filterResponsibilityTermStatus,
        this.filterPeriodType,
        this.filterStartDate,
        this.filterEndDate
      ]
    },
    drivers() {
      return this.getModels || []
    }
  },
  created() {
    this.defaultModelSetting.updateQueryURL = true
    this.order.push('updated_at', 'desc')
    this.$set(this.query, 'periodType', '')

    const today = new Date().toISOString().split('T')[0]
    this.$set(this.query, 'startDate', today)
    this.$set(this.query, 'endDate', today)

    this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
    this.filterCreatedBy = this.buildFilterEmail(this.allUsers.data)
    this.filterUpdatedBy = this.buildFilterEmail(this.allUsers.data)

    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })
  },
  data: () => ({
    currentDriver: null,
    filterAccount: null,
    filterCreatedBy: null,
    filterUpdatedBy: null,
    filterCategory: new Filter({
      key: 'category',
      label: 'Categoria',
      type: 'select',
      table: [
        { label: 'A', value: 'A' },
        { label: 'B', value: 'B' },
        { label: 'C', value: 'C' },
        { label: 'D', value: 'D' },
        { label: 'E', value: 'E' },
        { label: 'AB', value: 'AB' },
        { label: 'AC', value: 'AC' },
        { label: 'AD', value: 'AD' },
        { label: 'AE', value: 'AE' }
      ]
    }),
    filterCnhStatus: new Filter({
      key: 'cnhStatus',
      label: 'Status da CNH',
      type: 'select',
      table: [
        { label: 'Pendente', value: 'pending' },
        { label: 'Anexado', value: 'attached' },
      ]
    }),
    filterResponsibilityTermStatus: new Filter({
      key: 'responsibilityTermStatus',
      label: 'Status do Termo',
      type: 'select',
      table: [
        { label: 'Pendente', value: 'pending' },
        { label: 'Anexado', value: 'attached' }
      ]
    }),
    filterPeriodType: new Filter({
      key: 'periodType',
      label: 'Tipo de periodo',
      type: 'select',
      table: [
        { label: 'Data de criacao', value: 'created_at' },
        { label: 'Data de atualizacao', value: '' }
      ]
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    modelPathPrefix: 'admin/maestro',
    nameModel: 'Driver',
    orderBy: 'updated_at',
    showModal: false,
    showFilter: false
  }),
  inject: ['allAccounts', 'allUsers', 'buildFilterAccount', 'buildFilterEmail', 'getAccountName'],
  methods: {
    buildParams(pagination) {
      if (this.query.generic)
        this.query.generic = handleSearchable(this.query.generic)

      return this.$options.superMethods.buildParams.call(this, pagination)
    },
    find() {
      this.asyncTemplateSelect()
    },
    formatCpf(cpf) {
      if (!cpf) return ''
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    },
    formatPhone(phone) {
      if (!phone) return ''
      if (phone.length === 11) {
        return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
      } else if (phone.length === 10) {
        return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
      }
      return phone
    },
    showDriver(driver) {
      this.currentDriver = driver
      this.showModal = true
    },
    translateStatus(status) {
      const translations = {
        'Pending': 'Pendente',
        'Approved': 'Aprovado',
        'Rejected': 'Rejeitado',
        'Signed': 'Assinado'
      }
      return translations[status] || status
    }
  },
  mixins: [ModelMapper, GlobalLoading],
  name: 'MaestroDriversIndex',
  superMethods: {
    buildParams: ModelMapper.methods.buildParams
  },
  watch: {
    allAccounts: {
      deep: true,
      handler(value) {
        this.filterAccount = this.buildFilterAccount(value.data)
      }
    },
    allUsers: {
      deep: true,
      handler(value) {
        this.filterCreatedBy = this.buildFilterEmail(value.data)
        this.filterUpdatedBy = this.buildFilterEmail(value.data)
      }
    },
    orderBy(newValue, oldValue) {
      if (newValue === oldValue) return

      this.order = []
      this.addOrderBy(newValue, 'desc')
      this.find()
    }
  }
}
</script>

<style scoped>
</style>
